module.exports = __webpack_public_path__ + "static/media/narrow-contact.bf077074.svg";